import { useMemo } from 'react'
import { filterStoreRepo } from 'components/Filters/FilterStore'
import FilterModal, {
  FilterGroup,
} from 'components/Filters/components/FilterModal'
import {
  SelectFilter,
  SelectFilterOption,
} from 'components/Filters/fields/SelectFilter'
import {
  createFilterColumnHelper,
  DataTypeColumn,
} from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { FilterIdentifier } from 'models/saved_view'
import useApiService from 'services/api'
import { useGetFileExtensionOptions } from 'services/documentsApi'

type DealDocumentsFilterColumnKey = 'tags' | 'file_extension' | 'created_by'

const DEAL_DOCUMENTS_FILTER_COLUMNS: Record<
  DealDocumentsFilterColumnKey,
  DataTypeColumn
> = {
  tags: { header: 'Tags', group: 'Document Details' },
  file_extension: { header: 'File Type', group: 'Document Details' },
  created_by: { header: 'Uploaded By', group: 'People' },
}

interface DealDocumentsFiltersetProps {
  filterIdentifier: FilterIdentifier
}

/** Filter modal for the deal documents tab with tag, file type, and uploader filters. */
export default function DealDocumentsFilterset({
  filterIdentifier,
}: DealDocumentsFiltersetProps) {
  const api = useApiService()
  const { data: rawUserOptions } = api.useGetUserOptions({
    onlyActive: true,
    withNoneOption: true,
  })
  const { data: fileExtensionOptions } = useGetFileExtensionOptions()
  const { data: documentTagsOption } = api.useGetTagsOptions(true, 'documents')

  const userOptions: SelectFilterOption[] | undefined = useMemo(() => {
    return rawUserOptions?.map((option) => ({
      ...option,
      value: String(option.value),
    }))
  }, [rawUserOptions])

  const filterStore = filterStoreRepo.getStore(filterIdentifier)
  const filterHelper = createFilterColumnHelper({
    columns: DEAL_DOCUMENTS_FILTER_COLUMNS,
  })

  return (
    <FilterModal store={filterStore} identifier={filterIdentifier}>
      <FilterGroup title="Document Details">
        <SelectFilter
          {...filterHelper.retrieveProps('tags')}
          options={(documentTagsOption as SelectFilterOption[]) || []}
          filterStore={filterStore}
        />
        <SelectFilter
          {...filterHelper.retrieveProps('file_extension')}
          options={fileExtensionOptions || []}
          filterStore={filterStore}
        />
      </FilterGroup>
      <FilterGroup title="People">
        <SelectFilter
          {...filterHelper.retrieveProps('created_by')}
          options={userOptions || []}
          filterStore={filterStore}
        />
      </FilterGroup>
    </FilterModal>
  )
}
